import * as React from 'react';
import { Table } from 'semantic-grab-ui/src';
import _ from 'lodash';
import './CounterShow.scss';
import { Campaign } from 'types/ts/campaigns';

interface Props {
  model: Campaign,
  currentNode: string,
  parentNode: string,
  parentKeyList: string[],
};

export default class CounterShow extends React.Component<Props> {
  getStatsKey = (nodeID: string, target: string, targetIdx: string) => {
    const { model } = this.props;
    const targetKey = `${target}-${targetIdx}`; // e.g. occurrence-1
    return _.get(model, `nodeStatsKeyMapping.${nodeID}.${targetKey}`, 'Not Determined');
  };

  render() {
    const { model, currentNode, parentNode, parentKeyList } = this.props;
    // making countOptionList and byOptionList for counter prview, below piece of code is to form those list by taking care of parent node and chain scenario case.
    const countOptionList = [];
    const byOptionList = [
      { text: 'Occurrence', value: 'occurrence' },
      { text: 'Transaction Value', value: 'txAmount' },
    ];

    const parentNodeType = _.get(model.nodes[parentNode], 'type') === 'scenarios' ? 'scenarios' : 'condition';

    if (parentNodeType === 'scenarios') {
      _.get(model.nodes[parentNode], 'data.scenarios', []).forEach((scenario, index) => {
        countOptionList.push({ text: `${_.get(scenario, 'name', `Scenario ${index + 1}`)}`, value: `${index + 1}` });
      });
    } else {
      _.get(model.nodes[parentKeyList[0]], 'data.scenarios', []).forEach((scenario, index) => {
        countOptionList.push({ text: `${_.get(scenario, 'name', `Scenario ${index + 1}`)} with ${_.get(model.nodes[parentNode], 'name', 'Condition')}`, value: `${index + 1}` });
      });
    }

    const countOptionTypes = countOptionList.reduce((result, o) => {
      result[o.value] = o.text;
      return result;
    }, {});
    const byOptionTypes = byOptionList.reduce((result, o) => {
      result[o.value] = o.text;
      return result;
    }, {});
    return (
      <div>
        <Table striped>
          <Table.Body>
            {_.get(model.nodes[currentNode], 'data.targets', []).map((countData, index) => {
              const count = countData.match(/\d+/g) !== null ? countData.match(/\d+/g)[0] : '1';
              const by = countData[0] === 'o' ? 'occurrence' : 'txAmount';
              return (
                <Table.Row key={index}>
                  <Table.Cell>
                    <p>Count<span className="counterName"> {`${countOptionTypes[count]}`} </span> by {`${byOptionTypes[by]}`}</p>
                    <p className="statsKeyContainer">Key: <span className="statsKey">{this.getStatsKey(currentNode, by, count)}</span></p>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    );
  }
}
